import { useTranslation } from "react-i18next";
import * as yup from "yup";
import BaseForm from "../../../../../../shared/components/form/BaseForm";
import FormDatePicker from "../../../../../../shared/components/datepicker/FormDatePicker";
import FormInput from "../../../../../../shared/components/input/FormInput";

const EditObjectiveTrackerForm = ({ onSubmitHandler, tracker }) => {
  const { t } = useTranslation();

  const validationSchema = yup.object({
    beginDate: yup
      .date()
      .required(t("objectivesTracker.editForm.fields.beginDate.required")),
    endDate: yup
      .date()
      .required(t("objectivesTracker.editForm.fields.endDate.required")),
    name: yup
      .string()
      .required(t("objectivesTracker.editForm.fields.name.required")),
  });

  const defaultValues = {
    beginDate: new Date(tracker?.beginDate),
    endDate: new Date(tracker?.endDate),
    clientId: tracker?.client?.id,
    name: tracker?.name,
    goal: tracker?.result?.goal,
    threshold: 0,
  };

  return (
    <BaseForm
      validationSchema={validationSchema}
      defaultValues={defaultValues}
      onSubmitHandler={onSubmitHandler}
      isCreationForm={false}
    >
      <div className="flex flex-row justify-between gap-x-4">
        <div className="w-1/2">
          <FormDatePicker
            name="beginDate"
            label={t("objectivesTracker.editForm.fields.beginDate.label")}
            required
          />
        </div>
        <div className="w-1/2">
          <FormDatePicker
            name="endDate"
            label={t("objectivesTracker.editForm.fields.endDate.label")}
            required
          />
        </div>
      </div>
      <FormInput
        name="name"
        label={t("objectivesTracker.editForm.fields.name.label")}
        placeholder={t("objectivesTracker.editForm.fields.name.placeholder")}
        required
      />
      <FormInput
        type="number"
        name="goal"
        label={t("objectivesTracker.editForm.fields.goal.label")}
      />
    </BaseForm>
  );
};

export default EditObjectiveTrackerForm;
